import { api } from '../api';
import type { BannerContent } from './types';

// Mismo comportamiento visible que el antiguo BillingBanner.tsx (regresión cero,
// GOL-08A) — solo se movió de componente montado a proveedor consultado por AppBanner.
export async function getBillingBanner(navigate: (path: string) => void): Promise<BannerContent | null> {
  const data = await api.billing.entitlement().catch(() => null);
  if (!data) return null;

  const { status, trialDaysLeft } = data.entitlement;
  const trialActive = status === 'trialing' && (trialDaysLeft ?? 0) > 0;
  if (status === 'none' || status === 'active') return null;

  const managePayment = async () => {
    const { url } = await api.billing.portal();
    window.location.href = url;
  };

  if (trialActive) {
    const days = trialDaysLeft ?? 0;
    return {
      tone: days <= 2 ? 'warning' : 'neutral',
      message: `Prueba Pro · Te quedan ${days} ${days === 1 ? 'día' : 'días'} para probar todas las herramientas.`,
      actionLabel: 'Añadir método de pago',
      onAction: managePayment,
    };
  }
  if (status === 'past_due') {
    return {
      tone: 'warning',
      message: 'Pago pendiente · Conservas Pro mientras se revisa tu cobro.',
      actionLabel: 'Revisar mi pago',
      onAction: managePayment,
    };
  }
  if (status === 'unpaid') {
    return {
      tone: 'danger',
      message: 'Plan Gratis con factura pendiente · Liquida la factura para recuperar Pro.',
      actionLabel: 'Revisar mi pago',
      onAction: managePayment,
    };
  }
  return {
    tone: 'neutral',
    message: 'Plan Gratis · Tu sitio sigue publicado. Trabaja con los límites Gratis.',
    actionLabel: 'Ver opciones de plan',
    onAction: () => navigate('/billing'),
  };
}
